import React from 'react';
export function HeroSection() {
  return <div className="bg-[#002d4d] py-16 px-4 relative overflow-hidden" data-id="element-969">
      <div className="absolute inset-0 opacity-10" data-id="element-970">
        <div className="absolute -right-20 -top-20 w-96 h-96 rounded-full border-[20px] border-white" data-id="element-971"></div>
        <div className="absolute -left-20 -bottom-20 w-64 h-64 rounded-full border-[15px] border-white" data-id="element-972"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-973">
        <div className="bg-white p-8 rounded-2xl shadow-xl inline-block mb-8" data-id="element-974">
          <a href="https://www.bodor.com/us/" target="_blank" rel="noopener noreferrer" data-id="element-975">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/LOGOS/Bodor%20Laser%20Logo.png400x400.png" alt="Bodor Laser" className="block h-16 md:h-24 w-auto mx-auto" data-id="element-976" />
          </a>
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-white tracking-tight mb-4" data-id="element-977">
          Bodor Fiber Laser Cutting Machines
        </h1>
        <p className="text-xl text-white/80 max-w-2xl mx-auto" data-id="element-978">
          High-performance fiber laser solutions for sheet and tube cutting
        </p>
      </div>
    </div>;
}